module.exports = __webpack_public_path__ + "static/media/spid-idp-namirialid~PDxLtsax.745325fb.svg";